import React from "react";

import {
  RadioButtonChecked as RadioButtonCheckedIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
} from "@mui/icons-material";
import { Box, Typography, Divider } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { FragmentType } from "@/utils/type";
import KcalIcon from "@components/Icons/KcalIcon";

const useStyles = makeStyles()({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "8px 36px 8px 0px",
  },
  details: {
    display: "flex",
    flexDirection: "row",
  },
  description: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  calorieText: {
    marginRight: "3px",
  },
  macronutrientText: {
    marginLeft: "24px",
  },
  templateName: {
    textAlign: "left",
  },
});

const StyledKcalIcon = withStyles(KcalIcon, {
  root: {
    width: "18px",
    height: "18px",
    marginTop: "4px",
    marginRight: "5px",
  },
});

type Props = {
  template: FragmentType<typeof selectTemplateDialogListItem>;
  selected: boolean;
};

const selectTemplateDialogListItem = graphql(`
  fragment SelectTemplateDialogListItem on MealPlanTemplate {
    id
    name
    description
    durationDays
    recommendedCalories
    macronutrientsCarbohydratePercent
    macronutrientsProteinPercent
    macronutrientsFatPercent
  }
`);

const SelectTemplateDialogListItem: React.FC<Props> = ({
  template,
  selected,
}) => {
  const { classes } = useStyles();
  const proteins =
    template.macronutrientsProteinPercent != undefined
      ? `${template.macronutrientsProteinPercent}%`
      : "N/A";
  const carbohydrates =
    template.macronutrientsCarbohydratePercent != undefined
      ? `${template.macronutrientsCarbohydratePercent}%`
      : "N/A";
  const fats =
    template.macronutrientsFatPercent != undefined
      ? `${template.macronutrientsFatPercent}%`
      : "N/A";
  function setRadioState() {
    if (selected) {
      return <RadioButtonCheckedIcon />;
    }

    return <RadioButtonUncheckedIcon />;
  }
  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.description}>
          <Box>
            <Typography
              variant="subtitle1"
              color="textPrimary"
              className={classes.templateName}
            >
              {template.name ?? "N/A"}
            </Typography>
          </Box>
          <Box className={classes.details}>
            <StyledKcalIcon />
            <Typography
              variant="subtitle1"
              color="textPrimary"
              className={classes.calorieText}
            >
              {template.recommendedCalories ?? "N/A"}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              kcal
            </Typography>
          </Box>
        </Box>
        <Box className={classes.description}>
          <Box>
            <Typography variant="subtitle1" color="textSecondary">
              {template.durationDays} days
            </Typography>
          </Box>
          <Box className={classes.details}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              className={classes.macronutrientText}
            >
              C:{carbohydrates}
            </Typography>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              className={classes.macronutrientText}
            >
              P: {proteins}
            </Typography>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              className={classes.macronutrientText}
            >
              F:{fats}
            </Typography>
          </Box>
        </Box>
      </Box>
      {setRadioState()}
      <Divider variant="fullWidth" />
    </>
  );
};

export default SelectTemplateDialogListItem;
